<div class="p-4 products-container" *ngIf="dashboardData?.products; else displayForms">
  <h3>Products</h3>

  <table class="table">
    <thead class="thead-light">
      <tr>
        <th scope="col">Product</th>
        <th scope="col">Sales</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let product of dashboardData.products">
        <td class="d-flex product-details">
          <img [src]="product?.photos[0]?.small" alt="Product Image" />
          <p>{{ product.name }}</p>
        </td>
        <td>
          <div class="d-flex justify-content-between">
            <span>{{ getPercentage(product) }}%</span>
            <span>{{ getProductSales(product.id) }}/{{ product.max_quantity }}</span>
          </div>
          <div class="progress">
            <div class="progress-bar" role="progressbar" [style.width.%]="getProgressBarWidth(product)" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #displayForms>
  <div class="p-4 products-container">
    <h3>Products</h3>
    <table class="table">
      <thead class="thead-light">
        <tr>
          <th scope="col">Product</th>
          <th scope="col">Sales</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let form of dashboardData.forms">
          <td class="d-flex product-details">
            <p>{{ form.name }}</p>
          </td>
          <td>
            <div class="d-flex justify-content-between">
              <span *ngIf="form.maximum_registrations">{{ getFormPercentage(form) }}%</span>
              <span
                >{{ getFormsBySales(form.id) }} <ng-container *ngIf="form.maximum_registrations">/{{ form.maximum_registrations }}</ng-container>
              </span>
            </div>
            <div class="progress" *ngIf="form?.maximum_registrations">
              <div class="progress-bar" role="progressbar" [style.width.%]="getProgressBarWidthForForms(form)" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
